import { head, isEmpty, prop } from 'ramda'
import isAfter from 'date-fns/isAfter'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import Appwrite from '@/assets/appwrite'
import add from 'date-fns/add'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

/**
 * @TODO ALLE FUNKTIONEN AUßER `getInspectionsForDashboard` KÖNNEN AUCH FÜR OIL VERWENDET WERDEN.
 *       ALSO ALLE GENERISCH BENENNEN UND IN OIL EINBINDEN.
 */

export const getInspectionsForDashboard = async () => {
    const generalInspection = { dates: await loadGeneralInspection(), card: getGeneralInspectionCard() }
    const inspection = { dates: await loadInspections(), card: getInspectionsCard() }

    let lastInspection = getLastInspection(generalInspection.dates)
    let nextInspection = getNextInspection(lastInspection, generalInspection.card.interval)

    const generalInspectionIsDanger = isDanger(lastInspection, nextInspection, generalInspection.card.dangerDiff)
    const generalInspectionIsWarning = isWarning(lastInspection, nextInspection, generalInspection.card.warningDiff)

    lastInspection = getLastInspection(generalInspection.dates)
    nextInspection = getNextInspection(lastInspection, inspection.card.interval)
    const inspectionIsDanger = isDanger(lastInspection, nextInspection, inspection.card.dangerDiff)

    // Return by priority
    if (generalInspectionIsDanger) return generalInspection
    if (inspectionIsDanger) return inspection
    if (generalInspectionIsWarning) return generalInspection

    return inspection
}

export const getLastInspection = (dates) => {
    if (isEmpty(dates)) return null

    return prop('date', head(dates))
}

export const getNextInspection = (lastInspection, interval) => {
    if (!lastInspection) return null

    const addedDays = add(parseISO(lastInspection), interval)

    return new Date(addedDays)
}

export const loadDates = async (dbTable) => {
    const { documents } = await Appwrite.databases.listDocuments(Appwrite.DB_NAME, dbTable, [
        Appwrite.Query.orderDesc('date'),
    ])
    if (!documents.length) return []

    return documents.map(x => ({ id: x.$id, date: format(parseISO(x.date), 'yyyy-MM-dd'), created: x.$createdAt }))
}

export const loadGeneralInspection = async () => {
    return await loadDates('general_inspection')
}

export const loadInspections = async () => {
    return await loadDates('inspection')
}

export const getGeneralInspectionCard = () => ({
    interval: { years: 2 },
    warningDiff: 90,
    dangerDiff: 30,
})

export const getInspectionsCard = () => ({
    interval: { months: 12 },
    warningDiff: 90,
    dangerDiff: 30,
})

export const isDiffTriggered = (lastInspection, nextInspection, triggerDiff) => {
    if (!lastInspection || !nextInspection) return false
    if (isAfter(new Date(), nextInspection)) return true

    const diff = differenceInCalendarDays(nextInspection, new Date())

    return diff <= triggerDiff
}

export const isWarning = (lastInspection, nextInspection, triggerDiff) => {
    return isDiffTriggered(lastInspection, nextInspection, triggerDiff)
}

export const isDanger = (lastInspection, nextInspection, triggerDiff) => {
    return isDiffTriggered(lastInspection, nextInspection, triggerDiff)
}
